import { ToEntity } from 'core/common/mappers';
import { PhotoScan } from '../entities';
import { FacePhotoDTO } from '../services/dto';

export class FaceDtoMapper implements ToEntity<PhotoScan, FacePhotoDTO> {
  toEntity(dto: FacePhotoDTO): PhotoScan {
    return {
      photoId: dto.photoId,
      photo: dto.photo,
    };
  }
}
